<template>
  <b-badge class="kl-status" :style="badgeStyle" pill>
    {{ label }}
  </b-badge>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "InstructionalStatusBadge",
  props: {
    // E28 · Id del estado (`InstructionalStatus`), no ya un entero de lista fija.
    // Null => la pieza no tiene estado y se lee como "No iniciado".
    status: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      instructional_statuses: names.INSTRUCTIONAL_STATUSES,
    }),
    // El estado puede no estar en el catálogo: lo borraron, o la pieza es de otra
    // institución. En los dos casos se cae en "No iniciado", como antes con un
    // valor desconocido.
    instructionalStatus() {
      if (this.status == null) return null;
      return (
        this.instructional_statuses.find((x) => x.id == this.status) || null
      );
    },
    label() {
      if (!this.instructionalStatus)
        return this.$t("teaching.instructional.statusNotStarted");
      return this.instructionalStatus.name;
    },
    // El color viene del catálogo, así que la insignia ya no necesita una tabla
    // propia: con estados configurables no habría forma de mantenerla al día.
    badgeStyle() {
      const color =
        this.instructionalStatus && this.instructionalStatus.color
          ? this.instructionalStatus.color
          : "#c9d2d1";
      return {
        backgroundColor: color,
        color: this.$lightOrDark(color) ? "#2b2a2a" : "#ffffff",
      };
    },
  },
};
</script>

<style scoped>
.kl-status {
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-chip-fw, 600);
  padding: 0.25rem 0.6rem;
}
</style>
